import { iiqEndPoints } from '@Services/data/ApiHandler';
import store from '../redux/Store';
import { IAutomationTask } from './Interfaces';
import { AutomationTaskActions } from './Reducer';

const Api = {
    getAutomationTasks: async (callback?: (data: any) => void) => {
        const response = await iiqEndPoints.getAutomationTasks();
        if (response.isSuccess) {
            const automationTasks = response.data.automation_tasks.map(
                (automationTask) => {
                    return {
                        automationTaskUri:
                            automationTask.uri +
                            '?version=' +
                            automationTask.version,
                        automationTaskName: automationTask.dag_name,
                    };
                }
            );

            store.dispatch(
                AutomationTaskActions.updateAutomationTasks(automationTasks)
            );

            if (callback) {
                callback(automationTasks);
            }
        }
    },

    setAutomationTask: async (
        automationTask: IAutomationTask,
        callback?: () => void
    ) => {
        store.dispatch(
            AutomationTaskActions.setSelectedAutomationTaskUri(
                automationTask.automationTaskUri
            )
        );
        if (callback) {
            callback();
        }
    },
};

export default Api;
